import { storyblokEditable } from "@storyblok/react/rsc";
import { renderRichText } from "@storyblok/react";

import { SignupPromo as SignupPromoComponent } from "@/components/auth/SignupPromo";

type SignupPromoProps = {
  blok: any;
};

const SignupPromo = ({ blok }: SignupPromoProps) => (
  <div {...storyblokEditable(blok)}>
    <SignupPromoComponent
      subline={blok.subline}
      headline={blok.headline}
      introHtml={blok.intro ? renderRichText(blok.intro) : undefined}
      benefits={blok.benefits}
      outroHtml={blok.outro ? renderRichText(blok.outro) : undefined}
    />
  </div>
);

export default SignupPromo;
